module.exports = require("./es-GQ");